import * as API from './UserApi';
import { handleInvalidToken } from '../../api/responseInterceptor';
// import { establishSocket } from './socketActions';
import { getNamespace, getWorkspace, setAuthData } from '../../utils/storage';
import * as type from './UserType';

export const getPolyclinics =
    (service = API.getPolyclinics) =>
    async (dispatch) => {
        dispatch({
            type: type.GET_POLYCLINICS.REQUEST
        });
        return await service().then((response) => {
            const polyclinics = response?.data;
            const namespace = getNamespace();
            const workspace = getWorkspace();
            const findPolyClinic = polyclinics.find((item) => item.id === namespace);

            dispatch({
                type: type.GET_POLYCLINICS.SUCCESS,
                payload: polyclinics
            });

            if (findPolyClinic) {
                const param = {
                    polyclinic: workspace?.polyclinic,
                    clinic: workspace?.clinic
                };

                // setUserWorkspace(workspace);
                dispatch({
                    type: type.SET_WORKSPACE,
                    payload: param
                });
            }
            return response;
            // dispatch(establishSocket());
            // }
        });
    };
export const resetStore = () => (dispatch) => {
    dispatch({
        type: type.RESET_STORE
    });
};
export const isChangingClinic = (flag) => (dispatch) => {
    dispatch({
        type: type.IS_CHANGING_CLINIC,
        payload: flag
    });
};
export const changeWorkspace = (workspace) => (dispatch) => {
    dispatch({
        type: type.SET_WORKSPACE,
        payload: workspace
    });
};
export const deleteWorkspace = () => (dispatch) => {
    dispatch({
        type: type.DELETE_WORKSPACE
    });
};
// this is for when we don't have workspace in localStorage
// but we do have in redux store

export const logout =
    (refresh, service = API.logout) =>
    async () => {
        await service(refresh)?.then((response) => {
            if (response.status === 200) {
                handleInvalidToken();
            }
        });
    };
export const getUserInfo =
    (service = API.getUserInfo) =>
    async (dispatch) => {
        await service()?.then((res) => {
            dispatch({
                type: type.USER_INFO,
                payload: res?.data
            });
        });
    };

export const login =
    (credential, service = API.login) =>
    async () => {
        return await service(credential)?.then((response) => {
            const { access, refresh } = response.data;
            if (response.status === 200) {
                setAuthData(access, refresh);
            }
            return response;
        });
    };
export const createUser =
    (userProfile, service = API.createUser) =>
    async (dispatch) => {
        return await service(userProfile).then((response) => {
            dispatch({
                type: type.CREATE_USER,
                payload: response.data
            });
            if (response.status === 200 || response.status === 201) {
                dispatch({
                    type: 'ADD_MESSAGE',
                    payload: {
                        text: 'User successfully added',
                        status: 200
                    }
                });
            }
            return response;
        });
    };
export const getUsers =
    (namespace, service = API.getUsers) =>
    async (dispatch) => {
        dispatch({
            type: type.GET_USERS.REQUEST
        });
        return await service(namespace)?.then((response) => {
            dispatch({
                type: type.GET_USERS.SUCCESS,
                payload: response.data
            });
        });
    };

export const getUser =
    (userId, isFinding = false, service = API.getUser) =>
    async (dispatch) => {
        const namespace = getNamespace();
        if (!isFinding) {
            dispatch({
                type: type.GET_USER.REQUEST
            });
        }
        return await service(userId, namespace).then((response) => {
            dispatch({
                type: type.GET_USER.SUCCESS,
                payload: response.data
            });
        });
    };
export const findUser =
    (username, service = API.findUser) =>
    async (dispatch) => {
        const namespace = getNamespace();
        dispatch({
            type: type.USER_FOUND.REQUEST
        });
        return await service(username, namespace)
            .then((response) => {
                dispatch({
                    type: type.USER_FOUND.SUCCESS,
                    payload: response.data
                });
            })
            .catch(() => {
                dispatch({
                    type: type.USER_FOUND.FAILURE
                });
            });
    };
export const resetUserFound = () => (dispatch) => {
    dispatch({
        type: type.RESET_USER_FOUND
    });
};
export const editUserAccess =
    (userId, value, isYou, service = API.editUserAccess) =>
    async (dispatch) => {
        return await service(userId, value).then((response) => {
            dispatch({
                type: type.EDIT_USER_ACCESS,
                payload: {
                    id: response.data.id,
                    data: response.data,
                    isYou,
                    namespace: value?.namespace
                }
            });
            if (response.status === 200 || response.status === 201) {
                dispatch({
                    type: 'ADD_MESSAGE',
                    payload: {
                        text: 'User information successfully edited',
                        status: 200
                    }
                });
            }
            return response;
        });
    };

export const deleteUser =
    (userId, service = API.deleteUser) =>
    async (dispatch) => {
        const namespace = getNamespace();
        return await service(namespace, userId).then(() => {
            dispatch({
                type: type.DELETE_USER,
                payload: userId
            });
            dispatch({
                type: 'ADD_MESSAGE',
                payload: {
                    text: 'User successfully deleted',
                    status: 200
                }
            });
        });
    };
export const updateUserInfo =
    (userInfo, service = API.updateUserInfo) =>
    async (dispatch) => {
        return await service(userInfo).then((response) => {
            dispatch({
                type: 'ADD_MESSAGE',
                payload: {
                    text: 'User information updated successfully.',
                    status: 200
                }
            });
            dispatch({
                type: type.UPDATE_USER_INFO,
                payload: response.data
            });
        });
    };
export const changePassword =
    (credentials, service = API.changePassword) =>
    async (dispatch) => {
        return await service(credentials).then(() => {
            dispatch({
                type: 'ADD_MESSAGE',
                payload: {
                    text: 'Password changed successfully.',
                    status: 200
                }
            });
        });
    };
